import React from "react";
import Notifications from "react-notification-system-redux";
import NotificationIcon from "./NotificationIcon";

export const notify = ({ type = "success", title, message, time, size }) => {
  const dismiss = time || 7;
  let icon = (
    <NotificationIcon variant="primary" icon="success-circle" size={size} />
  );

  switch (type) {
    case "error":
      icon = <NotificationIcon variant="failure" icon="declined" size={size} />;
      break;
    case "warning":
      icon = (
        <NotificationIcon variant="secondary" icon="warning" size={size} />
      );
      break;
    case "bookmark":
      icon = (
        <NotificationIcon
          variant="secondary"
          icon="filled-bookmark"
          size={size}
        />
      );
      break;
    default:
      break;
  }
  return Notifications.success({
    children: icon,
    title,
    message: message,
    position: "tr",
    autoDismiss: dismiss
  });
};

export const closeNotify = () => Notifications.removeAll();



// WEBPACK FOOTER //
// ./src/components/libs/notification/actions.js